import cs from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import classes from './style.module.scss';

export default function HamburgerMenu({ onClick, active = false }) {
  const handleMenuClick = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <div className={classes.container}>
      <button
        type="button"
        onClick={handleMenuClick}
        className={cs({
          [classes.active]: active,
        })}
      >
        <span />
        <span />
        <span />
      </button>
    </div>
  );
}

HamburgerMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};
